<template>
      <div class="block">
        <div class="conter_bj">
          <br />
          <h2 class="notice-user">《云影像用户须知》</h2>
          <p class="notice-user-title">易联云影云影像服务协议</p>

          <p class="content">
            易联云影信息科技（西安）有限公司系医学影像“云”系统等医院影像科信息化产品的专业经营者，医学影像“云”系统采用国际领先、国内领先的远程移动影像传输技术，为医院信息化提供有力工具，实现用户不限时间地点的远程阅片、会诊需求。
          </p>
          <br />
          <p class="content">
            本协议条款是易联云影云影像经营者与用户（下称为“您”），共同缔结的对双方具有约束力的有效契约。易联云影云影像用户提供云影像上所展示的产品与服务（下称“易联云影”、“易联云影云影像”、“本服务”），并将不断更新服务内容，最新的易联云影云影像服务以平台上的相关产品及服务介绍的页面展示以及向用户实际提供的为准。
          </p>
          <h2 class="title-h">1、总则</h2>
          <p class="content">
            1.1
            您确认：您在使用本服务之前，已经充分阅读、理解并接受本服务条款的全部内容（特别是以加粗及/或下划线标注的内容），一旦您选择“√”并完成登陆流程或使用本服务，即表示您接受并遵守本服务条款之所有约定及相应的服务规则，并承诺不以任何理由主张本协议无效或要求撤销本协议。
          </p>
          <p class="content">
            1.2
            您同意：易联云影云影像有权随时对本服务条款及相应的服务规则内容进行单方面的变更，并有权以消息推送、网页公告等方式予以公布，而无需另行单独通知您；若您在本服务条款内容公告变更后继续使用本服务的，表示您已充分阅读、理解并接受修改后的协议内容，也将遵循修改后的条款内容使用本服务；若您不同意修改后的服务条款，您应立即停止使用本服务。
          </p>
          <h2 class="title-h">2、账户</h2>
          <p class="content">2.1 注册</p>
          <p class="content">
            2.1.1.
            注册者资格您确认，您应当是具备完全民事权利能力和完全民事行为能力的自然人、法人或其他组织。若您不具备前述主体资格，则您及您的监护人应承担因此而导致的一切后果，且易联云影有权注销（永久冻结）您的账户，并向您及您的监护人索偿。
          </p>
          <p class="content">2.1.2. 注册和账户</p>
          <p class="content">
            2.1.2.1.
            在您按照“二维码”登陆页面提示填写信息、阅读并同意本服务条款且完成全部程序后，或在您按照激活页面提示填写信息、阅读并同意本服务条款且完成全部激活程序后，或您以其他易联云影允许的方式实际使用本平台服务时，您即受本服务条款约束。
          </p>
          <p class="content">
            2.1.2.2.
            您了解并同意，易联云影可能会就某些产品或服务的开通，要求您提供更多的身份资料和信息，做进一步的身份认证或资格验证，您的账户只有在通过这些认证和验证之后，方可获得使用相关产品或服务的资格。
          </p>
          <p class="content">2.1.3. 信息</p>
          <p class="content">
            2.1.3.1.
            在完成注册或激活流程时，您应当按照法律法规要求，按相应页面的提示准确提供并及时更新您的资料，以使之真实、及时，完整和准确。如有合理理由怀疑您提供的资料错误、不实、过时或不完整的，易联云影有权向您发出询问及/或要求改正的通知，并有权直接做出删除相应资料的处理，直至中止、终止对您提供部分或全部服务。易联云影对此不承担任何责任，您将承担因此产生的任何直接或间接损失及不利后果。
          </p>
          <p class="content">
            2.1.3.2.
            您应当准确填写并及时更新您提供的电子邮件地址、联系电话、联系地址、邮政编码等联系方式，以便易联云影或其他会员与您进行有效联系，因通过这些联系方式无法与您取得联系，导致您在使用易联云影服务过程中产生任何损失或增加费用的，应由您完全独自承担。您了解并同意，您有义务保持您提供的联系方式的有效性，如有变更需要更新的，您应按易联云影的要求进行操作。
          </p>
          <h2 class="title-h">3、平台服务使用守则为有效保障您使用本服务的合法权益，您理解并同意接受以下规则：</h2>
          <p class="content">
            3.1
            您通过包括但不限于以下方式向易联云影发出的指令，均视为您本人的指令，不可撤回或撤销，您应自行对易联云影执行前述指令所产生的任何结果承担责任。
          </p>
          <p class="content">3.1.2. 通过与您的账号绑定的手机号码向易联云影发送的全部信息；</p>
          <p class="content">
            3.1.3.
            通过与您的账号绑定的其他硬件、终端、软件、代号、编码、代码、其他账户名等有形体或无形体向易联云影发送的信息；
          </p>
          <p class="content">3.1.4. 其他易联云影与您约定或易联云影认可的其他方式。</p>
          <p class="content">
            3.2
            您在使用本服务过程中，本服务条款内容、页面上出现的关于交易操作的提示或易联云影发送到您手机的信息（短信或电话等）内容是您使用本服务的相关规则，您使用本服务即表示您同意接受本服务的相关规则。您了解并同意易联云影有权单方修改服务的相关规则，而无须征得您的同意，服务规则应以您使用服务时的页面提示（或发送到该手机的短信或电话等）为准，您同意并遵照服务规则是您使用本服务的前提。
          </p>
          <p class="content">
            3.3
            易联云影可能会以电子邮件（或发送到您手机的短信或电话等）方式通知您服务进展情况以及提示您进行下一步的操作，但易联云影不保证您能够收到或者及时收到该邮件（或发送到该手机的短信或电话等），且不对此承担任何后果。因此，在服务过程中您应当及时登录到平台查看和进行交易操作。因您没有及时查看和对服务状态进行修改或确认或未能提交相关申请而导致的任何纠纷或损失，易联云影不负任何责任。
          </p>
          <p class="content">3.4 您授权易联云影可以通过向第三方审核您的身份和资格，取得您使用本服务的相关资料。</p>
          <p class="content">
            3.5
            在您开始使用易联云影的某一产品或服务前，可能需要和易联云影就这一产品或服务签订单独的服务协议。您只有在接受该服务协议的全部内容后方可使用该产品或服务；如您不同意该服务协议的部分或者全部的，请您不要进行后续操作。
          </p>
          <p class="content">
            3.6
            在您使用易联云影服务时，易联云影有权依照相应的产品/及或服务收费介绍、订单及/或相关协议向您收取服务费用。易联云影拥有制订及调整服务费之权利，具体服务费用以您使用本服务时页面上所列之收费方式公告或您与易联云影达成的其他书面协议为准。
          </p>
          <p class="content">
            3.7在您使用易联云影服务时，易联云影有权对您的影像数据进行保存，且默认对您的数据保存在云端或易联云影指定的保存地址中，且保存时间根据您的交费情况而定，如您没有按时交费则易联云影有权对您的数据进行单方面操纵（转存或删除等）。
          </p>
          <p class="content">
            3.8
            易联云影云影像不保证一定适合用户的使用要求和期望；不保证不受干扰或不被恶意攻击;不保证服务质量的及时、安全、可靠或不出现错误。
          </p>
          <p class="content">
            3.9本平台提供的在线预览或下载功能，选择该功能会将用户存储在云服务器上的文件下载到用户指定的位置。手机客户端在非Wi-Fi网络在线预览或下载文件，如在非Wi-Fi网络下下载所产生的流量费用，需要用户自己承担。
          </p>
          <h2 class="title-h">4、 您的权利和义务</h2>
          <p class="content">
            4.1
            您有权利享受易联云影提供的互联网技术和信息服务，并有权利在接受易联云影提供的服务时获得易联云影的技术支持、咨询等服务，服务内容详见本平台相关产品介绍。
          </p>
          <p class="content">4.2 您保证不会利用技术或其他手段破坏或扰乱本平台及易联云影其他客户的平台。</p>
          <p class="content">
            4.3
            您应尊重易联云影其他第三方的知识产权和其他合法权利，并保证在发生侵犯上述权益的违法事件时尽力保护易联云影及其股东、雇员、合作伙伴等免于因该等事件受到影响或损失；易联云影保留您侵犯易联云影合法权益时终止向您提供服务并不退还任何款项的权利。
          </p>
          <p class="content">
            4.4
            对由于您向易联云影提供的联络方式有误以及您用于接受易联云影邮件的电子邮箱安全性、稳定性不佳而导致的一切后果，您应自行承担责任，包括但不限于因您未能及时收到易联云影的相关通知而导致的后果和损失。
          </p>
          <p class="content">4.5您保证：</p>
          <p class="content">
            4.5.2.
            使用易联云影产品或服务时，应遵守您与易联云影签订的服务条款、易联云影在平台相关页面上的管理规范、流程、服务说明、价格说明和您确认同意的订购页面的内容，包括但不限于：
          </p>
          <p class="content">4.5.2.1. 您应按时付款；</p>
          <p class="content">
            4.5.2.2.
            不应出现任何破坏或试图破坏网络安全的行为等；如您违反上述保证，易联云影除有权根据相关服务条款采取删除信息、中止服务、终止服务的措施，并有权限制您账户如新购产品或服务、续费等部分或全部功能，如因您上述行为给易联云影造成损失的，您应予赔偿。
          </p>
          <p class="content">
            4.6
            若您使用的某项服务中包含可下载的易联云影软件，则易联云影仅授予您非独占性的、不可转让的、非商业运营目的的个人使用许可。除非易联云影另有明示或与您另有约定外，您不得复制、修改、发布、出售或出租服务或所含软件的任何部分，也不得进行反向工程或试图提取该软件的源代码。
          </p>
          <h2 class="title-h">5、 易联云影的权利和义务</h2>
          <p class="content">5.1 易联云影应根据您选择的服务以及交纳款项的情况向您提供合格的网络技术和信息服务。</p>
          <p class="content">
            5.2 易联云影承诺对您资料采取对外保密措施，不向第三方披露您资料，不授权第三方使用您资料，除非：
          </p>
          <p class="content">5.2.1. 依据本服务条款或者您与易联云影之间其他服务协议、合同、在线条款等规定可以提供；</p>
          <p class="content">5.2.2. 依据法律法规的规定应当提供；</p>
          <p class="content">5.2.3. 行政、司法等职权部门要求易联云影提供；</p>
          <p class="content">5.2.4. 您同意易联云影向第三方提供；</p>
          <p class="content">5.2.5. 易联云影解决举报事件、提起诉讼而提交的；</p>
          <p class="content">5.2.6. 易联云影为防止严重违法行为或涉嫌犯罪行为发生而采取必要合理行动所必须提交的；</p>
          <p class="content">
            5.2.7.
            易联云影为向您提供产品、服务、信息而向第三方提供的，包括易联云影通过第三方的技术及服务向您提供产品、服务、信息的情况。
          </p>
          <p class="content">
            5.3 易联云影有权根据本服务条款的约定，根据您的服务使用情况，自您的账户余额中直接扣除相关服务费用。
          </p>
          <h2 class="title-h">
            6、
            隐私及其他个人信息的保护一旦您同意本服务条款或使用本服务，您即同意易联云影按照以下条款来使用和披露您的个人信息。
          </h2>
          <p class="content">
            6.1
            易联云影会将依法收集到的您的个人信息用于审计、数据分析、研究和关联公司之间分享等内部目的，这样您可以更好地享受到易联云影为您提供的全面服务，易联云影也可以改进易联云影的产品与服务。
          </p>
          <p class="content">
            6.2.
            视具体情况，易联云影会向与易联云影合作提供产品和服务或者帮助易联云影向客户进行营销的合作伙伴提供某些个人信息。易联云影只会为提供或改进易联云影的产品、服务和广告宣传之目的而与第三方共享个人信息；而不会为第三方的营销目的与第三方共享个人信息，更不会销售个人信息。易联云影有义务要求上述合作伙伴严格遵守保密约定。
          </p>
          <h2 class="title-h">
            7、
            系统中断或故障系统可能因下列状况无法正常运作，使您无法使用各项互联网服务时，易联云影不承担损害赔偿责任，该状况包括但不限于：
          </h2>
          <p class="content">7.1 易联云影在系统停机维护期间。</p>
          <p class="content">7.2 电信设备出现故障不能进行数据传输的。</p>
          <p class="content">
            7.3 因台风、地震、海啸、洪水、停电、战争、恐怖袭击等不可抗力之因素，造成易联云影系统障碍不能执行业务的。
          </p>
          <p class="content">
            7.4 由于黑客攻击、电信部门技术调整或故障、网站升级、银行方面的问题等原因而造成的服务中断或者延迟。
          </p>
          <h2 class="title-h">8、 责任范围及责任限制</h2>
          <p class="content">8.1 易联云影仅对本服务条款中列明的责任承担范围负责。</p>
          <p class="content">
            8.2易联云影平台仅作为用户病人和医疗机构、专家医生在线交流平台，您应自行谨慎判断确定相关专家机构及/或信息的真实性、合法性和有效性，并自行承担因此产生的责任与损失。
          </p>
          <p class="content">
            8.3
            本服务之合作单位，所提供之服务品质及内容由该合作单位自行负责，易联云影并不对您选定并为您提供服务的医疗机构、专家医生的诊断意见及疗效负责。
          </p>
          <p class="content">
            8.4
            您了解并同意，因您使用本服务、违反本服务条款或在您的账户下采取的任何行动，而导致的任何第三方索赔，应且仅应由您本人承担。如果由此引起易联云影及其关联公司、员工、客户和合作伙伴被第三方索赔的，您应负责处理，并承担由此造成的全部责任。
          </p>
          <p class="content">
            8.5
            在法律允许的情况下，易联云影对于与本服务条款有关或由本服务条款引起的任何间接的、惩罚性的、特殊的、派生的损失（包括业务损失、收益损失、利润损失、使用数据、商誉或其他经济利益的损失），不论是如何产生的，也不论是由对本服务条款的违约（包括违反保证）还是由侵权造成的，均不负有任何责任，即使事先已被告知此等损失的可能性。另外即使本服务条款规定的排他性救济没有达到其基本目的，也应排除易联云影对上述损失的责任。
          </p>
          <p class="content">
            8.6
            除本服务条款另有规定或易联云影与您就某一具体产品及/或服务另有约定外，在任何情况下，您同意易联云影对本服务条款所承担的赔偿责任总额不超过向您收取的当次服务费用总额。
          </p>
          <h2 class="title-h">9、 商标、知识产权的保护</h2>
          <p class="content">
            9.1
            除第三方产品或服务外，本平台上所有内容均由易联云影或易联云影关联企业依法拥有其知识产权，包括但不限于商标权、专利权、著作权、商业秘密等。任何人不得擅自使用、修改、复制、公开传播、改变、散布、发行或公开发表本平台上程序或内容。任何侵权行为均应承担损害赔偿责任。
          </p>
          <h2 class="title-h">
            10、
            法律适用与管辖本服务条款之效力、解释、变更、执行与争议解决均适用中华人民共和国法律。因本服务条款产生之争议，均应依照中华人民共和国法律予以处理，并提交给易联云影信息技术（西安）有限公司注册所在地有管辖权的法院审判。
          </h2>
          <h2 class="title-h">11、本《服务条款》的一切解释权与修改权归易联云影公司所有。</h2>
          <h2 class="date">2020年7月</h2>
        </div>
        <div class="login_btn" @click="close">关闭</div>
      </div>
</template>

<script>
export default {
  data() {
    return {
    }
  },

  methods: {
    close() {
      this.$router.back()

    },
  },
}
</script>

<style  scoped>

.conter_bj {
  margin: auto;
  background: #fff;
  padding: 12px 15px;
  position: relative;
  left: 0;
}

.conter_bj h2 {
  font-size: 15px;
  color: #888;
  line-height: 28px;
}
.conter_bj h2 span {
  color: #111;
}
.conter_bj h2 i {
  color: #111;
  display: block;
}


.conter_bj .notice-user {
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  color: #333;
  font-family: PingFangSC-Regular, '微软雅黑', 'Hiragino Sans GB', 'Helvetica Neue';
}
.notice-user-title {
  text-align: center;
  width: 100%;
  font-size: 28px;
  font-weight: 700;
}
.content {
  text-indent: 2em;
  font-size: 14px;
}

.conter_bj .date {
  text-align: right;
  margin-right: 3em;
  font-size: 15px;
  font-weight: 600;
  font-family: PingFangSC-Regular, '微软雅黑', 'Hiragino Sans GB', 'Helvetica Neue';
  color: #333;
}
.conter_bj .title-h {
  font-size: 15px;
  font-weight: 560;
  font-family: PingFangSC-Regular, '微软雅黑', 'Hiragino Sans GB', 'Helvetica Neue';
  color: #333;
  margin-top: 8px;
}
.login_btn {
  width: 80%;
  height: 44px;
  border-radius: 22px;
  color: #fff;
  background-color: #40a5ff;
  font-size: 18px;
  line-height: 44px;
  text-align: center;
  margin: 10px auto 20px;
}
</style>
<style lang="less" scoped>
.block {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  background-color: #fff;
   margin-top: -15px
}
</style>